export default __webpack_public_path__ + "static/media/ninjapod-logo_white.7b7f5b66.png";